import React from 'react'
import { useOutletContext } from 'react-router-dom'
import BillingTerms from './BillingSettings/BillingTerms'
import OffersTable from '../../Tables/OffersTable'
import SectionHeadline from '../../../../Header/SectionHeadline'

export function BillingSettingsSection() {
  const { affiliate, canUpdateBillingRules } = useOutletContext()
  return (
    <div style={{ position: 'relative', paddingBottom: '30px', minHeight: '800px' }}>
      <SectionHeadline>Billing</SectionHeadline>
      <BillingTerms affiliate={affiliate} canUpdate={canUpdateBillingRules} />
      <OffersTable affiliate={affiliate} canUpdate={canUpdateBillingRules} />
    </div>
  )
}

BillingSettingsSection.propTypes = {
}

export default BillingSettingsSection
